/**
 * TabItem Component
 *
 * Individual navigation tab with close button
 * - Pill-shaped with active state
 * - Title truncation with ellipsis
 * - Close button (hover visible on desktop, always on mobile)
 */

import { memo } from 'react';
import clsx from 'clsx';
import { Tooltip } from '@mantine/core';
import { IconChecklist, IconNote, IconX } from '@tabler/icons-react';
import type { TabItemProps } from './NavigationTabs.types';
import styles from './TabItem.module.css';

const TAB_ICON_SIZE = 14;

export const TabItem = memo(function TabItem({
  tab,
  isActive,
  onClick,
  onClose,
}: TabItemProps) {
  const TabIcon = tab.type === 'note' ? IconNote : IconChecklist;

  return (
    <div
      className={clsx(styles.tab, isActive && styles.active)}
      onClick={onClick}
      role="tab"
      aria-selected={isActive}
      tabIndex={0}
    >
      <TabIcon size={TAB_ICON_SIZE} className={styles.tabIcon} />
      <Tooltip label={tab.title}>
        <span className={styles.tabTitle}>{tab.title}</span>
      </Tooltip>

      <button
        className={styles.closeButton}
        onClick={onClose}
        aria-label={`Close ${tab.title}`}
        type="button"
      >
        <IconX size={TAB_ICON_SIZE} />
      </button>
    </div>
  );
});
